<div class="headlines">Programming Interface</div>

<div class="headlines2">Basic Examples</div>
<p style="text-align: center;">Here are some basic examples of how to use the
    <a href="https://mtb.bioinf.med.uni-goettingen.de/CCS/doc/">API</a> in a terminal with <a href="https://curl.se/docs/manpage.html">curl</a>. 
</p>

<div class='api-example'>
    <input type="hidden" #selection>
    <div class="card-container">
        <button class="card card-small" (click)="selection.value = 'component'" tabindex="0">
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            <span>Liftover</span>
        </button>

        <button class="card card-small" (click)="selection.value = 'material'" tabindex="0">
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            <span>Genomic to Protein Position</span>
        </button>

        <button class="card card-small" (click)="selection.value = 'pwa'" tabindex="0">
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            <span>Protein to Genomic Position</span>
        </button>

        <button class="card card-small" (click)="selection.value = 'dependency'" tabindex="0">
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            <span>Gene Transcripts</span>
        </button>

        <button class="card card-small" (click)="selection.value = 'test'" tabindex="0">
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            <span>Gene Protein Sequence</span>
        </button>
    </div>

    <div class="terminal" [ngSwitch]="selection.value">
        <pre
            *ngSwitchDefault>curl -L "https://mtb.bioinf.med.uni-goettingen.de/CCS/v1/liftover/hg38%3Ahg19/chr17%3A7673776"</pre>
        <pre
            *ngSwitchCase="'material'">curl -L "https://mtb.bioinf.med.uni-goettingen.de/CCS/v1/GenomicToGene/hg38/chr17%3Ag.7673776G%3EA"</pre>
        <pre
            *ngSwitchCase="'pwa'">curl -L "https://mtb.bioinf.med.uni-goettingen.de/CCS/v1/GeneToGenomic/hg38/JAK1%3AL910P"</pre>
        <pre
            *ngSwitchCase="'dependency'">curl -L "https://mtb.bioinf.med.uni-goettingen.de/CCS/v1/getTranscripts/hg38/KRAS"</pre>
        <pre
            *ngSwitchCase="'test'">curl -L "https://mtb.bioinf.med.uni-goettingen.de/CCS/v1/get_protein_sequence/NM_005228.5"</pre>
    </div>
</div>

<div class="headlines2">Swagger UI</div>
<iframe src="https://mtb.bioinf.med.uni-goettingen.de/CCS/doc/" frameborder="0"></iframe>